import React, { useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { AppBar, Toolbar, Box } from "@mui/material";
import logo from "public/Kaleideo-white-logo.png";
import { fetchCurrentUser } from "features/auth/slices/authSlice";
import { getToken } from "lib/auth/authUtils";
import NotificationMenu from "shared/components/NotificationMenu";
import ProfileMenu from "shared/components/ProfileMenu";

const Navbar = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const authUser = useSelector((state) => state.auth.user);

  const user = useMemo(
    () => ({
      name: authUser
        ? `${authUser.first_name} ${authUser.last_name}`
        : "",
      role: authUser?.role || "",
      initials: authUser
        ? `${authUser.first_name?.[0] || ""}${authUser.last_name?.[0] || ""}`
        : "",
    }),
    [authUser],
  );

  useEffect(() => {
    if (!authUser && getToken()) {
      dispatch(fetchCurrentUser());
    }
  }, [dispatch, authUser]);

  const getNavLinkStyle = (path) => {
    let isActive = false;

    if (path === "/products") {
      isActive =
        location.pathname === path ||
        location.pathname.startsWith("/products/");
    } else if (path === "/documentation") {
      isActive =
        location.pathname === path ||
        location.pathname.startsWith("/documentation/");
    } else if (path === "/explore") {
      isActive =
        location.pathname === path || location.pathname === "/checkout";
    } else if (path === "/settings") {
      isActive =
        location.pathname === path ||
        location.pathname === "/settings/user-management";
    } else {
      isActive = location.pathname === path;
    }

    return {
      color: isActive ? "white" : "#2196f3",
      textDecoration: "none",
      fontSize: "16px",
      transition: "color 0.3s ease",
    };
  };

  const getIconButtonStyle = (path) => ({
    color: location.pathname === path ? "white" : "#2196f3",
    transition: "color 0.3s ease",
    "&:hover": {
      color: "#2196f3",
      backgroundColor: "rgba(33, 150, 243, 0.08)",
    },
  });

  return (
    <AppBar
      position="static"
      sx={{ backgroundColor: "black", padding: "2px 0px" }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          minHeight: "30px !important",
        }}
      >
        {/* Left: Logo & Navigation Links */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 5 }}>
          <Link to="/explore">
            <img
              src={logo}
              alt="KALEIDEO"
              style={{ height: "30px", cursor: "pointer" }}
            />
          </Link>

          <Link to="/explore" style={getNavLinkStyle("/explore")}>
            Explore
          </Link>
          <Link to="/orders" style={getNavLinkStyle("/orders")}>
            Orders
          </Link>
          <Link to="/products" style={getNavLinkStyle("/products")}>
            Products
          </Link>
          <Link to="/documentation" style={getNavLinkStyle("/documentation")}>
            Documentation
          </Link>
        </Box>

        {/* Right: Notification & Profile Menus */}
        <Box sx={{ display: "flex", gap: 2 }}>
          <NotificationMenu
            iconButtonSx={getIconButtonStyle("/notifications")}
          />
          <ProfileMenu
            user={user}
            iconButtonSx={getIconButtonStyle("/profile")}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
